import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import FrontBbsModuleTypes from '@/store/modules/frontDesk/bbs/interface';

const frontBbsModule: Module<FrontBbsModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        pageProjectList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/pageProjectList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        pageActivityList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/pageActivityList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listActivityTag(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listActivityTag", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listActivityBrand(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listActivityBrand", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listDeveloperName(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listDeveloperName", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listJoinCategory(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listJoinCategory", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        getActivity(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/getActivity", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        getActivityApply(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/getActivityApply", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveActivityApply(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/saveActivityApply", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        unloginSaveActivityApply(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/unloginSaveActivityApply", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listCompany(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listCompany", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveRssActivity(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/saveRssActivity", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
    },
};

export default frontBbsModule;